<!-- 查看导入记录结果页 -->
<template>
  <div class="basicStyle">
    <h1 style="margin-bottom: 20px">
      <!-- 成功导入数据{{ mainObj.succ_total }}条，开课费用总计{{
        mainObj.fee
      }}（用户激活后扣费），生成新用户账号{{ mainObj.account_total }}条 -->
      总数<span style="color: red">{{ queryInfo.total }}</span
      >条，导入成功<span style="color: red">{{ mainObj.succ_total }}</span
      >条，导入失败<span style="color: red">{{ mainObj.fail_total }}</span
      >条

      <div v-if="mainObj.fail_total > 0" style="display: inline-block">
        <MyButton
          value="下载失败数据"
          size="medium"
          type="3"
          @click="importDetail"
          style="margin-left: 20px"
        ></MyButton>
        <el-popover placement="bottombottom-start" width="300" trigger="hover">
          <div>
            <h3>下载失败报告：</h3>
            <div>【注】下载错误数据，可修改后重新导入</div>
          </div>
          <i class="el-icon--right questionIcon" slot="reference"></i>
        </el-popover>
      </div>
    </h1>
    <div class="table">
      <TableComponents
        :columns="columns"
        :tableData="tableList"
        :tableFunction="tableFunction"
      >
        <template slot="operation" slot-scope="{ row }">
          <div v-if="row.old_username && row.status !== 2">
            老用户，无需生成
          </div>
          <div v-else-if="!row.old_username && row.status !== 2">
            <p>生成新账号</p>
            <span class="operationItem" @click="copy(row)">复制账号密码</span>
          </div>
          <div v-else>
            <p>-</p>
          </div>
        </template>

        <template slot="result" slot-scope="{ row }">
          <div :style="{ color: row.status != 1 ? 'red' : '#606266' }">
            {{ row.result }}
          </div>
        </template>
      </TableComponents>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page"
        :page-sizes="[10, 30, 50, 80]"
        :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryInfo.total"
      >
      </el-pagination>
    </div>

    <!-- 新增编辑弹窗 -->
    <el-dialog
      :title="dialogType"
      :visible.sync="addFormShow"
      class="formDialog"
      width="500px"
    >
      <el-form
        :model="userInfo"
        :rules="rules"
        ref="userInfoForm"
        label-width="100px"
      >
        <el-form-item label="手机号：" prop="mobile">
          <el-input
            v-model="userInfo.mobile"
            placeholder="请输入手机号"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="真实姓名：" prop="realname">
          <el-input
            v-model="userInfo.realname"
            placeholder="请输入真实姓名(2-6个汉字）"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证：" prop="id_card">
          <el-input
            v-model="userInfo.id_card"
            placeholder="请输入身份证"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model="userInfo.remark"
            placeholder="请输入备注"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态：">
          <el-radio-group v-model="userInfo.status" size="mini">
            <el-radio-button :label="1">启用</el-radio-button>
            <el-radio-button :label="0">禁用</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import commonApi from "@/api/common.js";
import studentApi from "@/api/student.js";
import goodsApi from "@/api/goods.js";
import TableComponents from "@/components/TableComponents.vue";
import { clearObj, copyToClip } from "@/utils/index.js";
import MyButton from "@/components/MyButton.vue";
export default {
  name: "ImportRecordDeatail",
  components: {
    TableComponents,
    MyButton,
  },
  data() {
    var confirmPasswordVerify = (_, value, callback) => {
      if (!value) {
        return callback(new Error("确认密码不能为空"));
      } else if (value != this.codeInfo.new_password_confirmation) {
        return callback(new Error("两次密码输入需一致"));
      } else {
        callback();
      }
    };
    return {
      options: [],
      options1: [],
      loading: false,
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        type: "",
      },
      tableList: [],
      // 新增编辑表单数据
      addFormShow: false,
      userInfo: {
        mobile: "",
        realname: "",
        id_card: "",
        remark: "",
        status: 1,
        uid: "",
      },
      rules: {
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        realname: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
      },
      tableFunction: {
        checkData: 0, //是否允许勾选
        name: "choiceGoods",
      },

      // 选中的学员
      selectStudent: [],
      mainObj: {
        succ_total: "",
        account_total: "",
        fee: "",
      },
      recordId: "",
    };
  },
  computed: {
    dialogType() {
      //  'this.userInfo.id',this.userInfo.uid);
      return this.userInfo.uid ? "编辑" : "新增";
    },
    columns() {
      //  'this.$route.query.type',this.$route.query.type);
      if (this.$route.query.type && Number(this.$route.query.type)) {
        return [
          { label: "考试类别", prop: "app_type_names" },
          { label: "真实姓名", prop: "realname" },
          { label: "手机号", prop: "mobile" },
          { label: "身份证号", prop: "id_card" },
          { label: "备注", prop: "remark" },
          { label: "导入结果", prop: "result", isMyself: true },
        ];
      } else {
        return [
          { label: "考试类别", prop: "app_type_names" },
          { label: "真实姓名", prop: "realname" },
          { label: "手机号", prop: "mobile" },
          { label: "身份证号", prop: "id_card" },
          // { label: "余额扣费", prop: "userImportfee" },
          { label: "备注", prop: "remark" },
          // { label: "用户名（老用户需填）", prop: "old_username" },
          // { label: "是否生成新账号", prop: "operation" },
          { label: "导入结果", prop: "result", isMyself: true },
        ];
      }
    },
  },
  watch: {
    selectBuyGoodsShow: {
      handler(_newVal) {
        //  _newVal);
      },
    },
    addFormShow: {
      handler(_newVal) {
        if (!_newVal) {
          Object.keys(this.userInfo).forEach((key) => {
            if (typeof this.userInfo[key] == "string") {
              this.userInfo[key] = "";
            } else if (typeof this.userInfo[key] == "number") {
              this.userInfo[key] = 1;
            }
          });
          this.userInfo.uid = "";
        }
      },
    },
  },
  created() {
    this.recordId = this.$route.query.recordId;
    this.queryTable();
  },
  methods: {
    importDetail() {
      this.$confirm("是否确定导出失败数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          commonApi
            .studentsImportListDetail({
              record_id: this.recordId,
              status: 2,
              limit: 1000,
            })
            .then((res) => {
              if (res.code === 200) {
                console.log("studentsImportListDetail", res.data);
                this.$message({
                  type: "success",
                  message: res.message,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消导出",
          });
        });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(async () => {
          this.loading = false;
          const companyName = query;
          const res = await studentApi.tobGoodList({ good_name: companyName });
          this.options = res.data;
        }, 200);
      } else {
        this.options = [];
      }
    },
    remoteMethod1(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(async () => {
          this.loading = false;
          const companyName = query;
          const res = await studentApi.tobTagsList({ name: companyName });
          this.options1 = res.data.data;
        }, 200);
      } else {
        this.options = [];
      }
    },
    // 列表数据
    async queryTable(_type) {
      if (_type) {
        this.queryInfo.page = 1;
      }
      this.queryInfo.record_id = this.$route.query.recordId;
      const res = await commonApi.studentsImportListDetail(this.queryInfo);
      if (res.code == 200) {
        this.queryInfo.total = res.data.total;
        this.tableList = res.data.data;

        this.tableList.forEach((item, index) => {
          this.tableList[index].userImportfee = item.fee;
          if (item.username) {
            this.tableList[index].usernamePass =
              "用户名：" + item.username + "，密码" + item.password;
          } else {
            this.tableList[index].usernamePass = "-";
          }
        });
        Object.assign(this.mainObj, res.data.analysis);
        //  this.tableList);
      } else {
        this.$message.error(res.message);
      }
    },
    // 打开弹窗
    viewDetail(row) {
      if (row.uid) {
        Object.assign(this.userInfo, row);
      }
      //  this.userInfo);
      this.addFormShow = true;
    },
    // 添加｜｜修改数据
    addUser(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res;
          if (this.userInfo.uid) {
            res = await studentApi.studentsEdit(this.userInfo);
          } else {
            res = await studentApi.studentsAdd(this.userInfo);
          }
          if (res.code == 200) {
            this.$message.success(`${this.dialogType}成功`);
            this.queryTable();
            this.addFormShow = false;
          } else {
            this.$message.error(res.message);
          }
        } else {
          //  'error submit!!');
          return false;
        }
      });
    },

    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
    resetQuery() {
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        status: -1, //状态 -1全部 1启用 0禁用
        is_active: -1, //是否激活 -1全部 1启用 0禁用
        keyword: "", //用户信息 支持账号真实姓名手机号
        start_time: "", //创建开始时间
        end_time: "", //创建结束时间
        tag_id: "", //标签id
        id_card: "", //身份证号
      };
      this.queryTable();
    },
    // 选择日期
    selectData(e) {
      //  e);
      this.queryInfo.start_time = e[0];
      this.queryInfo.end_time = e[1];
    },

    choiceGoods(e) {
      //  e);
      this.selectStudent = e;
    },
    async addCourse() {
      let _obj = this.selectStudent.map((item) => {
        return item.uid;
      });
      const res = await goodsApi.addCoursePower({
        tob_user_id: _obj.join(","),
        course_id: this.$route.query.courseId,
      });
      if (res.code == 200) {
        this.$message.success("添加学员成功");
      } else {
        this.$message.error(res.message);
      }
    },
    // 一键复制功能
    copy(row) {
      copyToClip(`登录账号：${row.username};密码：${row.password}`);
      this.$message.success("复制成功！");
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 20px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
      }
      /deep/ .el-input {
        width: 230px;
      }
    }
    /deep/ .el-button--primary {
      margin-left: 50px;
    }
  }
  .addInfo {
    margin: 20px 0;
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
    .studentLabel {
      display: inline-block;
      padding: 5px 10px;
      background-color: #409eff;
      color: #fff;
      border-radius: 4px;
      margin: 0 5px 5px 0;
    }
  }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}

.questionIcon {
  width: 19px;
  height: 19px;
  background-image: url("../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  margin-left: 10px;
}
.questionIcon:hover {
  background-image: url("../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}
</style>
